import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { myApi } from "../api";

const MyAuthContext = createContext(null);

export function MyAuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const u = await myApi.me();
      setUser(u);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    const u = await myApi.login(email, password);
    setUser(u);
    return u;
  };

  const logout = async () => {
    // Limpa a sessão MY no servidor
    try { await myApi.logout(); }
    catch (e) { console.warn("[MY] logout endpoint failed, clearing local state anyway:", e); }
    // Limpa também a sessão CRM principal — sem isto fica em loop
    // /login ↔ /areas porque o cookie crm_session continua válido.
    try { await fetch("/api/auth/logout", { method: "POST", credentials: "include" }); }
    catch (e) { console.warn("[MY] CRM logout failed:", e); }
    setUser(null);
  };

  return (
    <MyAuthContext.Provider value={{ user, loading, login, logout, refresh }}>
      {children}
    </MyAuthContext.Provider>
  );
}

export const useMyAuth = () => useContext(MyAuthContext);
